// extracted by mini-css-extract-plugin
export var leftPane = "SplitPane-module__leftPane___EwXgW";
export var pageColumn = "SplitPane-module__pageColumn___xqJgy";
export var pageRow = "SplitPane-module__pageRow___O5rjf";
export var rightPane = "SplitPane-module__rightPane___NNhso";